import { useEffect, useState, useCallback } from 'react';
import ScrollArea from 'react-scrollbar';
import { WsCheckboxList } from 'wisestep-base';

import WsAccordion from './WsAccordion';

interface CheckboxListFilterProps {
  name: string;
  title: string;
  options: {
    [key: string]: string;
  };
  disabled?: boolean;
  infoText?: string;
  startIcon?: React.ReactElement;
  defaultExpanded?: boolean;
}

const CheckboxListFilter = ({
  name,
  title,
  options,
  disabled,
  infoText,
  startIcon,
  defaultExpanded = false,
}: CheckboxListFilterProps) => {
  const size = 15;
  const [optionList, setOptionList] = useState<any>({});
  const [start, setStart] = useState<number>(0);
  const last = Object.entries(options).length;

  const addElementInOption = useCallback(() => {
    const keyList = Object.keys(options);
    for (let index = 0; index < keyList.length; index++) {
      if (index >= start && index < start + size)
        optionList[keyList[index]] = options[keyList[index]];
      if (index > start + size) break;
    }
    setOptionList(optionList);
  }, [optionList, start, options]);

  /**  Hooks Events */
  useEffect(() => {
    addElementInOption();
  }, [addElementInOption]);

  const onScroll = () => {
    const startIndex = start + size;

    if (startIndex < last + size) {
      setTimeout(() => {
        setStart(startIndex);
        addElementInOption();
      }, 100);
    }
  };

  return (
    <>
      <WsAccordion
        title={title}
        disabled={disabled}
        infoText={infoText}
        {...(startIcon && { startIcon: startIcon })}
        defaultExpanded={defaultExpanded}
      >
        <ScrollArea
          speed={0.8}
          className="area"
          contentClassName="content"
          horizontal={false}
          minScrollSize={10}
          smoothScrolling={true}
          onScroll={() => onScroll()}
        >
          <WsCheckboxList name={name} options={optionList} />
        </ScrollArea>
      </WsAccordion>
    </>
  );
};

export default CheckboxListFilter;
